import { computed } from 'vue'

import useAnalyticsStore from '@/store/analytics'

export const useRefreshButton = () => {
  
  const analyticsStore = useAnalyticsStore()
  
  const isRefreshButtonVisible = computed(() => analyticsStore.isWaitingToRefresh)
  
  const handleRefreshAnalytics = () => {
    analyticsStore.markAsDeprecated()
  }

  return {
    isRefreshButtonVisible,
    handleRefreshAnalytics,
  }
}
